/* eslint-disable react/no-array-index-key -- These will never be reordered so it doesn't matter */
import { CustomResponsiveTr } from "features/History/utils/HistoryCustomTableStyle";
import { FC } from "react";
import { Skeleton, TableCell, TableRow } from "shared/components/Spor";

type TableSkeletonProps = {
  numOfRows: number;
  numOfColumns: number;
};

export const TableSkeleton: FC<TableSkeletonProps> = ({
  numOfRows,
  numOfColumns,
}) => (
  <>
    {Array.from({ length: numOfRows }).map((_row, rowIndex) => (
      <TableRow key={rowIndex}>
        {Array.from({ length: numOfColumns }).map((_column, colIndex) => (
          <TableCell key={colIndex}>
            <Skeleton height="18px" my="6px" width="100%" />
          </TableCell>
        ))}
      </TableRow>
    ))}
  </>
);

export const TableSkeletonHistory: FC<TableSkeletonProps> = ({
  numOfRows,
  numOfColumns,
}) => (
  <>
    {Array.from({ length: numOfRows }).map((_row, rowIndex) => (
      <CustomResponsiveTr key={rowIndex}>
        {Array.from({ length: numOfColumns }).map((_column, colIndex) => (
          <TableCell
            key={colIndex}
            className={colIndex === 3 ? "DontShowIfSmallWidth" : ""}
          >
            <Skeleton height="24px" my="6px" width="70%" />
          </TableCell>
        ))}
      </CustomResponsiveTr>
    ))}
  </>
);
